module.exports = __webpack_public_path__ + "static/media/down.6cc8da65.svg";